module.exports = __webpack_public_path__ + "img/user_avatar.3dc5934c.png";